import React from 'react';
import clsx from 'clsx';

export interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

/** 52×30 toggle; on = orange. */
export const Switch: React.FC<SwitchProps> = ({ checked, onChange, label, disabled, className }) => (
    <label className={clsx('inline-flex items-center gap-3 cursor-pointer select-none', disabled && 'opacity-50 pointer-events-none', className)}>
        <input type="checkbox" role="switch" className="peer sr-only" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
        <span className="relative h-[30px] w-[52px] shrink-0 rounded-pill bg-neutral-300 transition-colors duration-200 peer-checked:bg-accent-500 peer-focus-visible:outline peer-focus-visible:outline-[3px] peer-focus-visible:outline-offset-2 peer-focus-visible:outline-accent-500 after:absolute after:left-[3px] after:top-[3px] after:h-6 after:w-6 after:rounded-full after:bg-white after:shadow-sm after:transition-transform after:duration-200 after:ease-spring peer-checked:after:translate-x-[22px]" />
        {label && <span className="text-base font-semibold text-ink-primary">{label}</span>}
    </label>
);
export default Switch;
